import noop from "../noop";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function ButtonLink(props) {
  var { children, onClick } = props;
  var handler = onClick || noop;
  return (
    <a {...props} href="#" onClick={(e) => { e.preventDefault(); handler(e); }}>
      {children}
    </a>
  );
});
